module.exports = __webpack_public_path__ + "img/icon-2.8900c955.png";